import { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
let cache = null;

export const useSiteImages = () => {
    const [map, setMap] = useState(cache || {});

    useEffect(() => {
        if (cache) return;
        let active = true;
        axios
            .get(`${BACKEND_URL}/api/images`)
            .then((r) => {
                cache = r.data.images || {};
                if (active) setMap(cache);
            })
            .catch(() => {});
        return () => {
            active = false;
        };
    }, []);

    return (slot, fallback) =>
        map[slot] ? `${BACKEND_URL}${map[slot]}` : fallback;
};

export const SiteImg = ({ slot, fallback, ...props }) => {
    const img = useSiteImages();
    return <img src={img(slot, fallback)} {...props} />;
};
